// extracted by mini-css-extract-plugin
export default {"SizeReadout":"SizeReadout_SizeReadout__Qfhdu"};